module.exports = __webpack_public_path__ + "img/625-unit.b60b7826.png";